import { ApiCMSRequest } from "data/ApiCMS";
import { SchemaData, UseUpdateProps } from "./types";
import { useCallback } from "react";
import { JsonFormsStateProps } from "components/CRPComponents/JsonForm/JsonFormsComponent/types";
import { UPDATE_QUERY, UpdateGql } from "../queries/update";

export default function useUpdate({ queryParam }: UseUpdateProps) {
  const handleSave = useCallback(
    async (state: JsonFormsStateProps<SchemaData>) => {
      const { relatedPostsIds, relatedEventsIds, relatedProductsIds, tagsIds, ...data } = state?.data;

      const response = await ApiCMSRequest<UpdateGql>({
        query: UPDATE_QUERY,
        variables: {
          data: {
            ...data,
            relatedPostsIds: !relatedPostsIds ? [] : relatedPostsIds,
            relatedEventsIds: !relatedEventsIds ? [] : relatedEventsIds,
            relatedProductsIds: !relatedProductsIds ? [] : relatedProductsIds,
            tagsIds: !tagsIds ? [] : tagsIds,
            id: queryParam,
          },
        },
      });

      if (response?.data?.errors) {
        console.log(response?.data?.errors);
        throw response.data.errors[0];
      }
      if (!response?.data?.data) {
        throw new Error("Ops. Sem resposta!");
      }
      return response;
    },
    [queryParam]
  );

  return {
    handleSave,
  };
}
